import {
    actionCreator,
    API_URL,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
} from '../../../../../../../../actions/utilAction';

export {
    jsonApiHeader,
    showWarningMessage,
    showErrorMessage,
    actionCreator,
    checkHttpStatus,
    create_post_data,
    createSearchUrl,
    showSuccessMessage
};

export const POST_SKILLACQUISITIONTARGET_API = `${API_URL}/api/PatientSkillAcquisitionTarget/SavePatientSkillAcqTarget`;
export const GET_SKILLACQUISITIONTARGET_LIST_API = `${API_URL}/api/PatientSkillAcquisitionTarget/GetPatientSkillAcqTargets`;
export const GET_SKILLACQUISITIONTARGET_DETAIL_API = `${API_URL}/api/PatientSkillAcquisitionTarget/GetPatientSkillAcqTargetById`;
export const DELETE_SKILLACQUISITIONTARGET_API = `${API_URL}/api/PatientSkillAcquisitionTarget/DeletePatientSkillAcqTarget`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const TARGET_STATUS_ACTIVATION = `${API_URL}/api/PatientSkillAcquisitionTarget/UpdateTargetActiveStatus`;
export const PATCH_TARGET_STATUS = `${API_URL}/api/PatientSkillAcquisitionTarget/UpdateTargetStatus`;

export const GET_SKILL_ACQ_COLLECTEDDTTDATA_BY_TARGETID = `${API_URL}/api/PatientSkillAcquisitionTarget/GetPatientSkillAcqCollectedDTTDataByTargetId`
export const GET_SKILL_ACQ_COLLECTED_TA_DATA_BY_TARGETID = `${API_URL}/api/PatientSkillAcquisitionTarget/GetPatientSkillAcqCollectedTADataByTargetId`

export const UPDATE_SKILL_ACQ_COLLECTED_DTT_DATA_STATUS_API = `${API_URL}/api/PatientSkillAcquisitionTarget/UpdateCollectedDTTData`;
export const UPDATE_SKILL_ACQ_COLLECTED_TA_DATA_STATUS_API = `${API_URL}/api/PatientSkillAcquisitionTarget/UpdateCollectedTAData`;

export const UPDATE_SKILL_ACQ_COLLECTED_DTT_DATA_PROMPT_CODE_API = `${API_URL}/api/PatientSkillAcquisitionTarget/UpdateCollectedDTTDataPromptCode`;
export const UPDATE_SKILL_ACQ_COLLECTED_TA_DATA_PROMPT_CODE_API = `${API_URL}/api/PatientSkillAcquisitionTarget/UpdateCollectedTADataPromptCode`;

export const DELETE_SKILL_ACQ_COLLECTED_DTT_DATA_API = `${API_URL}/api/PatientSkillAcquisitionTarget/DeleteCollectedDTTData`;
export const DELETE_SKILL_ACQ_COLLECTED_TA_DATA_API = `${API_URL}/api/PatientSkillAcquisitionTarget/DeleteCollectedTAData`;
export const POST_COPYPATIENTSKILLACQUISITIONTARGET_API = `${API_URL}/api/PatientSkillAcquisitionProgram/CopyPatientSkillAcquisitionTarget`;

export const GET_GETPATIENTSKILLACQUISITIONTARGETSINGLEGRAPH_API = `${API_URL}/api/PatientSkillAcquisitionTarget/GetPatientSkillAcquisitionTargetSingleGraph`;
export const UPDATE_BATCH_TARGET_STATUS = `${API_URL}/api/PatientSkillAcquisitionTarget/UpdateBatchTargetStatus`;
export const UPDATE_BATCH_ACTIVE_STATUS = `${API_URL}/api/PatientSkillAcquisitionTarget/UpdateBatchActiveStatus`;

export const POST_SkillsAcquisitionRawData = `${API_URL}/api/CollectData/SavePatientSkillsAcquisitionRawData`;
export const POST_RAWSKILLAQUISITIONBEHAVIORDATA_API = `${API_URL}/api/CollectData/SaveRawSkillAquisitionBehaviorData`;
export const GET_RAWSKILLAQUISITIONBEHAVIORDATALIST_BY_TARGETID = `${API_URL}/api/PatientSkillAcquisitionTarget/GetPatientSkillAquisitionBehaviorCollectDataByTargetId`;
export const UPDATE_COLLECTEDSKILLAQUISITIONBEHAVIORDATA = `${API_URL}/api/PatientSkillAcquisitionTarget/UpdateSkillAquisitionBehaviorCollectedData`;
export const DELETE_SKILLAQUISITIONBEHAVIORCOLLACTDATA = `${API_URL}/api/PatientSkillAcquisitionTarget/DeleteSkillAquisitionBehaviorCollectedData`;
export const Get_PatientSkillAcqTargets_Data_ForDailySummary = `${API_URL}/api/PatientSkillAcquisitionTarget/GetPatientSkillAcqTargetsDataForDailySummary`;

export const skillAcquisitionTargetActionTypes = {
    get_masterData: createRequestActionTypes('GET_MASTERDATA'),
    save_skillAcquisitionTarget: createRequestActionTypes('SAVE_SKILLACQUISITIONTARGET'),
    get_skillAcquisitionTargetList: createRequestActionTypes('GET_SKILLACQUISITIONTARGETLIST'),
    get_skillAcquisitionTargetDetail: createRequestActionTypes('GET_SKILLACQUISITIONTARGETDETAIL'),
    delete_skillAcquisitionTarget: createRequestActionTypes('DELETE_SKILLACQUISITIONTARGET'),
    target_active_status: createRequestActionTypes('TARGET_ACTIVE_STATUS'),
    patch_target__status: createRequestActionTypes('PATCH_TARGET_STATUS'),
    get_skillAcqCollectedDTTDataBytTargetId: createRequestActionTypes('GET_SKILL_ACQ_COLLECTEDDTTDATA_BY_TARGETID'),
    get_skillAcqCollectedTADataBytTargetId: createRequestActionTypes('GET_SKILL_ACQ_COLLECTED_TA_DATA_BY_TARGETID'),
    update_skillAcqCollectedDTTDataStatus: createRequestActionTypes('UPDATE_SKILL_ACQ_COLLECTED_DTT_DATA_STATUS'),
    update_skillAcqCollectedTADataStatus: createRequestActionTypes('UPDATE_SKILL_ACQ_COLLECTED_TA_DATA_STATUS'),
    update_skillAcqCollectedDTTDataPromtCode: createRequestActionTypes('UPDATE_SKILL_ACQ_COLLECTED_DTT_DATA_PROMPT_CODE'),
    update_skillAcqCollectedTADataPromtCode: createRequestActionTypes('UPDATE_SKILL_ACQ_COLLECTED_TA_DATA_PROMPT_CODE'),
    delete_skillAcqCollectedDTTData: createRequestActionTypes('DELETE_SKILL_ACQ_COLLECTED_DTT_DATA'),
    delete_skillAcqCollectedTAData: createRequestActionTypes('DELETE_SKILL_ACQ_COLLECTED_TA_DATA'),
    save_copyPatientSkillAcquisitionTarget: createRequestActionTypes('SAVE_COPYPATIENTSKILLACQUISITIONTARGET'),
    get_getPatientSkillAcquisitionTargetSingleGraph: createRequestActionTypes('GET_GETPATIENTSKILLACQUISITIONTARGETSINGLEGRAPH'),
    update_batch_target_status: createRequestActionTypes('UPDATE_BATCH_TARGET_STATUS'),
    save_SkillsAcquisitionRawData: createRequestActionTypes('SAVE_SKILLSACQUISITIONRAWDATA'),
    update_batch_active_status: createRequestActionTypes('UPDATE_BATCH_ACTIVE_STATUS'),
    save_rawskillaquisitionbehaviordata: createRequestActionTypes('SAVE_RAWSkillAquisitionBehaviorDATA'),
    get_skillAcquisitionBehaviorCollactDataListByTargetId: createRequestActionTypes('GET_RAWSKILLAQUISITIONBEHAVIORDATALIST_BY_TARGETID'),
    update_collectedSkillAquisitionBehaviorDataStatus: createRequestActionTypes('UPDATE_COLLECTEDSKILLAQUISITIONBEHAVIORDATA'),
    delete_skillAquisitionBehaviorCollactData: createRequestActionTypes('DELETE_SKILLAQUISITIONBEHAVIORCOLLACTDATA'),
    setIsEventOccureSABCollactDataListByTargetIdFalse:createRequestActionTypes('SET_IS_EVENTOCCURE_SAB_COLLACT_DATA_BY_TARGET_ID_FALSE'),
    setIsEventOccureSkillAcqFalse: createRequestActionTypes('SET_IS_EVENT_OCCURE_SKILL_ACQ_FALSE'),
    get_PatientSkillAcqTargets_Data_ForDailySummary : createRequestActionTypes('Get_PatientSkillAcqTargets_Data_ForDailySummary')
};

export const MODULE = 'DCMASTER_SKILLACQUISITIONTARGET';


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Target/constants/ApiConstants.js